import React from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import { datetimeFromUTC } from 'utils/dayjs';
import { Skeleton } from '@mui/material';
import { times } from 'utils/render';
import './index.sass';

const { block, el } = bem('front-specialist-teaser');
export const FrontSpecialistTeaser = ({ specialist, onClick}) => {
    const { name, specialisation, direction, slug, closestEvent } = specialist.data;
    const { photo } = specialist;
    const { date, time } = datetimeFromUTC(closestEvent);
    const formatEvent = `${date} ${time}`;
    return (
        <Layout
            slug={slug}
            PhotoBlock={PhotoBlock({photo, name})}
            NameBlock={NameBlock({specialisation, name})}
            DescriptionBlock={DescriptionBlock({ direction })}
            BottomBlock={BottomBlock({event: formatEvent})} />
    )
}

export const TeaserSkeleton = () => {
    const PhotoBlock = <Skeleton variant='rectangular' height={'100%'} style={{borderRadius: '20px'}}><TeaserPhoto /></Skeleton>;
    const TopBlock = <>
        <Skeleton key={1} height={10} style={{marginBottom: '5px', fontSize: '12px', lineHeight: '14px'}} width={`50%`}/>
        <Skeleton key={2} height={10} style={{marginBottom: '5px', fontSize: '24px', lineHeight: '30px'}} width={`70%`}/>
    </>
    const DescriptionBlock = times((key) => <Skeleton key={key} style={{marginBottom: '3px', fontSize: '10px', lineHeight: '12px'}} width={`${70 + Math.random() * 30}%`}/>, 3)
    const BottomBlock = <Skeleton variant='rectangular' width={'100%'} height={42} style={{borderRadius: '10px'}}/>
    return (
        <Layout
            PhotoBlock={PhotoBlock}
            NameBlock={TopBlock}
            DescriptionBlock={DescriptionBlock}
            BottomBlock={BottomBlock}
        />
    )
}

const Layout = ({slug, PhotoBlock, NameBlock, DescriptionBlock, BottomBlock}) => {
    return (
        <Link className={block()} to={`/specialists/${slug}`}>
            <div className={el('top-block')}>
                <div className={el('photo')}>
                    {PhotoBlock}
                </div>
                <div className={el('spacer')} />
                <div className={el('name-block')}>
                    {NameBlock}
                </div>
                <div className={el('description')}>
                    {DescriptionBlock}
                </div>
            </div>
            <div className={el('closest-event-block')}>
                {BottomBlock}
            </div>
        </Link>
    )
}

const PhotoBlock = ({photo, name}) => <TeaserPhoto src={photo} alt={`Фото специалиста ${name}`} />;

const NameBlock = ({specialisation, name}) => (
    <>
        <div className={el('speciality')}><Text>{specialisation}</Text></div>
        <div className={el('name')}><Text serif={true} dangerouslySetInnerHTML={{__html: name}} /></div>
    </>
)

const DescriptionBlock = ({direction}) => <Text>{direction}</Text>;

const BottomBlock = ({event}) => (
    <>
        <div className={el('event')}>
            <Text className={el('event-label')}>Ближайшая запись</Text>
            <Text className={el('event-date')}>{event}</Text>
        </div>
        <Icon name={'caret-right'} />
    </>
)

